// extracted by mini-css-extract-plugin
export default {"modalHeader":"ConfirmChangePrimaryModal_modalHeader__n4Qb9","modalBody":"ConfirmChangePrimaryModal_modalBody__kGVqf"};